import notfound from "assets/images/notfound.png";
import DropDownButtons from "components/Ui/DropDownButtons/DropDownButtons";
import TableBodyCells from "components/Ui/TableBodyCells/TableBodyCells";

const Banner = (props) => {
    const cellRenderers = {
        id: () => <td>{props.banner?.id}</td>,
        image: () => (
            <td className="name">
                <span>
                    <div>
                        <img
                            src={props.banner.image ? props.banner.image : notfound}
                            alt="banner"
                        />
                    </div>
                </span>
            </td>
        ),
        title: () => <td>{props.banner?.content}</td>,
        description: () => <td>{props.banner?.discription}</td>,
        city: () => <td>{props.banner?.city.name}</td>,
        status: () => (
            <td>
                {props.banner?.status === "disabled"
                    ? "عدم ظهور"
                    : props.banner?.status === "optional"
                      ? "ظهور اختياري"
                      : "ظهور اجباري"}
            </td>
        ),
        actions: () => (
            <td>
                <DropDownButtons
                    banner={props.banner}
                    edit={() => {
                        props.setSelectedBannerValue(props.banner);
                        props.toggleEditForm();
                    }}
                ></DropDownButtons>
            </td>
        ),
    };

    return (
        <tr className="item">
            <TableBodyCells visibleColumns={props.visibleColumns} renderers={cellRenderers} />
        </tr>
    );
};

export default Banner;
